<mat-slide-toggle [checked]="checked" [disabled]="disabled" (change)="toggleChanged($event)">
  <ng-content></ng-content>
</mat-slide-toggle>
